var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.753,
    height: 8.752,
    viewBox: "0 0 8.753 8.752",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M2310.084,3097.125a.8.8,0,0,0-1.538,0l-.054.186a.8.8,0,0,1-.995.542.777.777,0,0,1-.157-.065l-.169-.093a.8.8,0,0,0-1.087,1.087l.092.171a.8.8,0,0,1-.477,1.151l-.186.055a.8.8,0,0,0,0,1.537l.186.055a.8.8,0,0,1,.477,1.151l-.093.17a.8.8,0,0,0,1.087,1.087l.17-.093a.8.8,0,0,1,1.087.32.813.813,0,0,1,.065.157l.054.186a.8.8,0,0,0,1.538,0l.054-.186a.8.8,0,0,1,1-.542.845.845,0,0,1,.157.065l.169.093a.8.8,0,0,0,1.087-1.087l-.092-.17a.8.8,0,0,1,.32-1.086.818.818,0,0,1,.157-.065l.186-.055a.8.8,0,0,0,0-1.537l-.186-.055a.8.8,0,0,1-.542-.994.776.776,0,0,1,.065-.157l.093-.17a.8.8,0,0,0-1.087-1.087l-.17.092a.8.8,0,0,1-1.152-.477Zm-.769,5.405a1.6,1.6,0,1,1,1.6-1.6,1.6,1.6,0,0,1-1.6,1.6Z",
    transform: "translate(-2304.938 -3096.551)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/setting-icon.dcb0ee815c1ae9c610c28a27997e19a7.svg";
export { ForwardRef as ReactComponent };